import theme from '../../../lib/theme';
import Article from '../../../views/Article';
import { ArticleReelBlockProps } from './ArticleReelBlock';

const {
	layouts,
	colors,
	scale,
	media,
	font: { families, heights, spacings, ...font },
} = theme;

export default ({
}: ArticleReelBlockProps) => ({
	container: {
		width: '100%',
		display: 'flex',
	}
});